Object.defineProperty(exports, "__esModule", { value: true });
const debounceAnimationFrame = (fn) => {
    let timeout;
    const debouncedFn = (...args) => {
        cancelAnimationFrame(timeout);
        return new Promise(resolve => {
            timeout = requestAnimationFrame(() => {
                const result = fn(...args);
                resolve(result);
            });
        });
    };
    return debouncedFn;
};
exports.default = debounceAnimationFrame;
